// extracted by mini-css-extract-plugin
export var addressFields = "_ot-0";
export var animationContainer = "_ot-1";
export var footer = "_ot-2";
export var lineItems = "_ot-3";
export var modalContent = "_ot-4";
export var orderName = "_ot-5";
export var strong = "_ot-6";
export var warning = "_ot-7";